import { history } from '@/redux/lib/configureStore';
import isNewTabNavigationEvent from './isNewTabNavigationEvent.js';

export const setPath = (newPathname, opts = {}) => {
  const validPathname = String(newPathname || '').trim();
  const currentParams = opts?.keepSearch ? window.location.search : '';
  const target = opts?.target || '_self';

  if (!validPathname) {
    return;
  }

  const url = `${validPathname}${currentParams}`;

  if (isNewTabNavigationEvent(opts?.event) || target === '_blank') {
    window.open(url, '_blank', 'noopener,noreferrer');
    return;
  }

  if (target !== '_self') {
    window.open(url, target);
    return;
  }

  opts?.replace === false ? history.push(url) : history.replace(url);
};

export default setPath;
